const UPDATE_SMARTCHAT_STATE = 'UPDATE_SMARTCHAT_STATE';

export { UPDATE_SMARTCHAT_STATE };
